﻿import { Component, OnInit } from '@angular/core';


@Component({ templateUrl: 'failure.component.html' })
export class PublicFailureComponent implements OnInit {


    constructor() {
    }


    ngOnInit() {
    }

   

}
